import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgenticPlanningRelayProvider = {
	get(): boolean {
		return (
			fg('jira-ai-agentic-planning-technical-changes') ||
			fg('jira_ai_task_level_planning_ootb_agent')
		);
	},
};

export default JiraAiAgenticPlanningRelayProvider;
